module.exports = __webpack_public_path__ + "assets/1398e8bcfef376d736ffb3b3c8f73b2f.svg";